import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";
import { Observable } from "rxjs";
import { MessageService } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class BasketImportService {
  // ========================
  // URL
  // ========================
  private readonly basketeUrl = 'koncentro-promo/basket';
  private readonly basketImportList = '/getImportBasketHeadList';

  basketId: string = null;

  constructor(
    private http: HttpClientService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) { }

  // ========================
  // BASKET LIST
  // ========================
  list(
    offset = null,
    limit = 999999,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: any[]; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(
      offset,
      limit,
      search,
      globalSearch,
      sort,
      sort_dir
    );

    let url = `${this.basketeUrl}${this.basketImportList}?${params.toString()}`;
    if (this.basketId) {
      url += `&basket_id=${this.basketId}`;
    }

    return this.http.getPaged(url);
  }



}





// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-import.service.ts